import React from 'react'
import { ActionIcon } from '@mantine/core'

function Icon({ width, height, color = 'currentColor' }) {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      viewBox="0 0 16 16"
      class="design-iconfont"
      width={width}
      height={height}
    >
      <path
        fill={color}
        d="M11.8461538,2 L7.69230769,2 C7.43740704,2 7.23076923,2.20663781 7.23076923,2.46153846 C7.23076923,2.71643912 7.43740704,2.92307692 7.69230769,2.92307692 L9.08153846,2.92307692 L5.75938462,13.0769231 L4.46153846,13.0769231 C4.20663781,13.0769231 4,13.2835609 4,13.5384615 C4,13.7933622 4.20663781,14 4.46153846,14 L8.61538462,14 C8.87028527,14 9.07692308,13.7933622 9.07692308,13.5384615 C9.07692308,13.2835609 8.87028527,13.0769231 8.61538462,13.0769231 L7.26353846,13.0769231 L10.5884615,2.92307692 L11.8461538,2.92307692 C12.1010545,2.92307692 12.3076923,2.71643912 12.3076923,2.46153846 C12.3076923,2.20663781 12.1010545,2 11.8461538,2 Z"
        fill-rule="nonzero"
      />
    </svg>
  )
}
const FontItalicIcon = (props) => {
  const {
    fill = 'blue',
    variant = 'transparent',
    size = 'lg',
    radius = 'lg',
    width = 20,
    height = 20,
    loading = false,
    disabled = false,
  } = props
  return (
    <ActionIcon
      color={fill}
      variant={variant}
      size={size}
      radius={radius}
      loading={loading}
      disabled={disabled}
    >
      <Icon width={width} height={height} />
    </ActionIcon>
  )
}

export default FontItalicIcon
